module.exports = __webpack_public_path__ + "img/H5.b2113c0d.png";